module.exports = __webpack_public_path__ + "static/media/warning_red.d0fef1f9.svg";